import { useQuery } from 'react-query'
import { useShowSnackbar } from '@chilipiper/design-system'
import { personal } from '@chilipiper/service'
import { Session } from '@chilipiper/models'
import { bookingLinkService } from './services'

export const useUserBookingLinkQuery = (userId = Session.user().id) => {
  const showSnackbar = useShowSnackbar()
  const { data, isLoading } = useQuery(
    ['UserBookingLink', userId],
    () => {
      if (userId) {
        const onRejected = (err: any) => {
          showSnackbar({ title: 'Error fetching personal booking link', type: 'error' })
          console.error(err)
          return undefined
        }

        const fullLinkPromise = bookingLinkService
          .all({ userId })
          .then(links => links.find(item => item.isDefault))
          .catch(onRejected)

        const linkUrlPromise = personal
          .getUserLink(userId)
          .then(({ link }) => link)
          .catch(onRejected)

        return Promise.all([fullLinkPromise, linkUrlPromise])
      }
    },
    {
      refetchOnWindowFocus: false,
    }
  )

  if (!data) {
    return { isLoading }
  }

  const [bookingLink, bookingLinkUrl] = data

  return { bookingLink, bookingLinkUrl, isLoading }
}
